export default "/images/1d65d4177dde1d48f080701c5c4c0081.avif";